import i18next from 'i18next';
import { z } from 'zod';
import { zodI18nMap } from 'zod-i18n-map';

/**
 * Sets up Zod internationalization with automatic language switching
 * Call this once during app initialization
 */
export function setupZodI18n(): void {
  // Set the initial error map
  z.setErrorMap(zodI18nMap);

  // Update error map when language changes
  i18next.on('languageChanged', () => {
    z.setErrorMap(zodI18nMap);
  });
}